<template>
 <div class='block-small-content'>
   <div class='block-small-content-text'>
     {{typeText}} {{textClock}} {{item.startTime}} {{postponedText}} {{canceledText}}<br>
     <a :href='item.textLink' :title='item.title'>{{item.title}}</a>
   </div>
 </div> 
</template>

<script>
import consts from '../../consts'
import lang from '../../lang'

export default {
  name: 'slider-item',
  data () {
    return {
      typeText: {},
      textClock: lang.clock[this.$root.cmsData.lang].toLowerCase(),
      canceledText: this.item.status === consts.status.canceled ? `- ${lang.canceled[this.$root.cmsData.lang]}` : '',
      postponedText: this.item.status === consts.status.postponed ? `- ${lang.postponed[this.$root.cmsData.lang]}` : ''
    }
  },
  created () {
    this.typeText = this.item.isHearing ? lang.hearing[this.$root.cmsData.lang] : lang.storting[this.$root.cmsData.lang]
  },
  props: ['item']
}
</script>



// WEBPACK FOOTER //
// SliderItemInformation.vue?3aa824aa